<se-fe-modal #modal
  (seFeAfterClose)="onAfterClose()">
  <se-fe-modal-content>
    <se-fe-header *ngIf="loaded" [seFeDataTitle]="translationKey + 'title' | translate" seFeDataSize="section">
      <se-fe-icon-button seFeHeaderActions [seFeDataSmall]="true" (click)="onClose()"> 
        <se-fe-icon 
          seFeDataName="close" 
          seFeDataSize="500"
          seFeDataAriaLabel="close">
        </se-fe-icon>
      </se-fe-icon-button>
    </se-fe-header>
  </se-fe-modal-content>
  <div seFeModalContent *ngIf="loaded && persona">
    <se-fe-alert
      class="invite-error"
      seFeDataType="error"
      *ngIf="error">
      {{ error }}
    </se-fe-alert>
    <div [ngSwitch]="step">
      <se-po-invite #invite *ngSwitchCase="stepEnum.Invite"
        [persona]="persona"
        (inviteAdded)="onInviteAdded($event)"
        (inviteSkipped)="onSkip()">
      </se-po-invite>
      <se-po-invite-review *ngSwitchCase="stepEnum.InviteReview"
        [invites]="invites"
        [guardianEmails]="guardianEmails"
        (back)="onStart()"
        (cancel)="onCancel($event)"
        (continue)="onContinue()">
      </se-po-invite-review>
    </div>
  </div>
</se-fe-modal>
<se-fe-toast></se-fe-toast>
